import { render, staticRenderFns } from "./FormSaveButton.vue?vue&type=template&id=7d27ca8f&"
import script from "./FormSaveButton.vue?vue&type=script&lang=js&"
export * from "./FormSaveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports